export default {"src":"/_next/static/media/wallbox-logo.53c205a8.svg","height":90,"width":175};